import React from 'react';
import Chart from 'react-apexcharts';
import { ApexOptions } from 'apexcharts';
import { useTranslation } from 'react-i18next';
import { useWindowSize } from '../../../hooks/windowSize';

import { useStyles } from './styles';
import { IGetMttrVsFailsChartData } from '../../../types/kpis';

interface IScatterWithAreaProps {
  title?: string;
  data: IGetMttrVsFailsChartData;
  showLegend?: boolean;
  columnWidth?: string;
  width?: string | number;
  height?: string | number;
  marginBottom?: number;
  marginTop?: number;
  marginRight?: number;
  marginLeft?: number;
  xaxisTitle?: string;
  yaxisTitle?: string;
}

const ScatterWithAreaChart: React.FC<IScatterWithAreaProps> = ({
  data,
  title,
  width,
  height,
  marginBottom,
  marginTop,
  marginLeft,
  marginRight,
  xaxisTitle,
  yaxisTitle,
}) => {
  const classes = useStyles();
  const { t } = useTranslation();
  const size = useWindowSize();

  const areaData = [
    {
      name: 'MTTR',
      type: 'scatter',
      data: data.scatterData,
    },
    {
      name: t('components:charts.acuteFailures'),
      type: 'area',
      data: data.sharpFails,
    },
    {
      name: t('components:charts.noFlaws'),
      type: 'area',
      data: data.noFails,
    },
    {
      name: t('components:charts.acuteAndChronicFailures'),
      type: 'area',
      data: data.chronicAndSharpFails,
    },
    {
      name: t('components:charts.chronicFailures'),
      type: 'area',
      data: data.chronicFails,
    },
  ];

  const options: ApexOptions = {
    chart: {
      type: 'scatter',
      fontFamily: 'Poppins',
      toolbar: {
        show: false,
      },
      sparkline: {
        enabled: false,
      },
      redrawOnParentResize: true,
      redrawOnWindowResize: true,
    },
    dataLabels: {
      enabled: false,
    },
    stroke: {
      show: false,
    },
    title: {
      text: title?.toLocaleUpperCase(),
      floating: true,
      align: 'center',
      offsetX: 14,
      style: {
        fontWeight: 700,
        fontFamily: 'Poppins',
        fontSize: '16px',
      },
    },
    xaxis: {
      labels: {
        show: true,
      },
      title: {
        text: xaxisTitle,
        style: {
          fontWeight: 500,
        },
      },
    },
    yaxis: {
      axisBorder: {
        show: true,
      },
      title: {
        text: yaxisTitle,
        style: {
          fontWeight: 500,
        },
      },
      max: data.sharpFails[1][1],
      tickAmount: 4,
    },
    plotOptions: {
      area: {
        fillTo: 'end',
      },
    },
    legend: {
      show: false,
    },
    tooltip: {
      enabled: false,
    },
    fill: {
      type: 'solid',
    },
    markers: {
      size: [6, 0, 0, 0, 0],
    },
    colors: ['#7030A0', '#F2B7B7', '#ABF4AB', '#F4F4AB', '#F4DAAB'],
  };

  return (
    <div
      className={classes.root}
      style={{ marginBottom, marginTop, marginLeft, marginRight }}
    >
      {/* {showTitle && title && (
        <Typography className={classes.title} variant="h3">
          {title}
        </Typography>
      )} */}
      <Chart
        options={options}
        series={areaData}
        type="scatter"
        height={height || '100%'}
        width={width || (size.width ? size.width * 0.25 : '100%')}
      />
    </div>
  );
};

export default ScatterWithAreaChart;
